/* TODA DELICADA · Versão 10 · gallery / variant synchronisation */
(function(){
'use strict';
function boot(){
 const root=document.querySelector('[data-td-gallery]');
 if(!root||root.dataset.tdV10==='true')return;
 const main=root.querySelector('[data-td-main]');
 const buttons=Array.from(root.querySelectorAll('[data-td-gallery-thumb]'));
 const tiles=Array.from(root.querySelectorAll('.td-visual-gallery__side'));
 const rail=root.querySelector('.td-visual-gallery__thumbs');
 if(!main||!buttons.length)return;
 root.dataset.tdV10='true';
 const norm=s=>String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
 let variants=[];try{variants=JSON.parse(document.querySelector('#td-pdp-variant-media-map')?.textContent||'[]')}catch(e){}
 const groups=Array.from(document.querySelectorAll('[data-td-picker] fieldset'));
 const colorIndex=groups.findIndex(g=>/cor|color|colour|couleur/i.test(g.querySelector('legend')?.textContent||''));
 const colors=colorIndex<0?[]:Array.from(new Set(variants.map(v=>String(v.options?.[colorIndex]||'')).filter(Boolean)));
 const items=buttons.map((button,index)=>({button,index,id:String(button.dataset.mediaId||''),src:button.dataset.src||'',alt:button.dataset.alt||'',color:''}));
 // Prioritize explicit image ALT text; infer remaining photos from the media
 // sequence anchored by each variant's associated image. Never guess from size.
 const sortedColors=colors.slice().sort((a,b)=>b.length-a.length);
 const colorInAlt=alt=>{
  const source=' '+norm(alt).replace(/[^a-z0-9]+/g,' ')+' ';
  return sortedColors.find(c=>source.includes(' '+norm(c).replace(/[^a-z0-9]+/g,' ')+' '))||'';
 };
 const anchors=new Map();
 for(const v of variants){
  if(colorIndex<0||!v.mediaId)continue;
  const item=items.find(x=>x.id===String(v.mediaId));
  if(item&&!anchors.has(item.index))anchors.set(item.index,String(v.options?.[colorIndex]||''));
 }
 items.forEach(item=>{item.color=colorInAlt(item.alt)||anchors.get(item.index)||''});
 // Use consecutive image groups only when clearly delimited by variant anchors.
 if(anchors.size){
  const positions=Array.from(anchors.keys()).sort((a,b)=>a-b);
  for(let p=0;p<positions.length;p++){
   const start=positions[p],end=p+1<positions.length?positions[p+1]:items.length;
   const color=anchors.get(start);
   for(let i=start;i<end;i++)if(!items[i].color)items[i].color=color;
  }
  if(positions[0]>0&&positions.length===1){
   for(let i=0;i<positions[0];i++)if(!items[i].color)items[i].color=anchors.get(positions[0]);
  }
 }
 let selected=-1,activeColor='';
 const same=(a,b)=>norm(a)===norm(b);
 function show(index){
  const chosen=items[index];if(!chosen?.src)return;
  selected=index;
  main.removeAttribute('srcset');main.removeAttribute('sizes');
  main.src=chosen.src;main.alt=chosen.alt;
  buttons.forEach((b,i)=>{b.classList.toggle('is-selected',i===index);b.setAttribute('aria-pressed',String(i===index))});
  const color=chosen.color||activeColor;
  const remaining=items.filter(item=>item.index!==index&&item.src!==chosen.src);
  const sameColor=color?remaining.filter(item=>same(item.color,color)):[];
  const alternatives=remaining.filter(item=>!sameColor.includes(item));
  const recommended=[...sameColor,...alternatives].slice(0,tiles.length);
  tiles.forEach((tile,i)=>{
   const candidate=recommended[i],img=tile.querySelector('[data-td-side]');
   if(!img)return;
   tile.hidden=!candidate;
   if(candidate){img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=candidate.src;img.alt=candidate.alt||''}
   else {img.removeAttribute('src');img.alt=''}
  });
  root.classList.toggle('td-visual-gallery--no-details',recommended.length===0);
  root.classList.toggle('td-visual-gallery--one-detail',recommended.length===1);
  root.classList.toggle('td-visual-gallery--two-details',recommended.length>=2);
 }
 buttons.forEach((button,index)=>button.addEventListener('click',event=>{
  event.preventDefault();event.stopPropagation();
  show(index);
 }));
 // Only a new colour/variant changes the manual photo choice.
 function onVariant(event){
  const variant=variants.find(v=>String(v.variantId)===String(event.detail?.variantId||''));
  if(!variant)return;
  const nextColor=colorIndex<0?'':String(variant.options?.[colorIndex]||'');
  if(activeColor&&nextColor&&same(activeColor,nextColor))return;
  activeColor=nextColor;
  let index=items.findIndex(item=>item.id===String(variant.mediaId||''));
  if(index<0&&nextColor)index=items.findIndex(item=>same(item.color,nextColor));
  if(index>=0)show(index);
 }
 document.addEventListener('td:variant-gallery-change',onVariant);
 const queryVariant=new URLSearchParams(location.search).get('variant');
 const initial=variants.find(v=>String(v.variantId)===queryVariant);
 const initialColor=initial&&colorIndex>=0?String(initial.options?.[colorIndex]||''):'';
 activeColor=initialColor;
 const idx=initial?.mediaId?items.findIndex(x=>x.id===String(initial.mediaId)):-1;
 show(idx>=0?idx:0);
 const previous=root.querySelector('[data-td-gallery-scroll="-1"]');
 const next=root.querySelector('[data-td-gallery-scroll="1"]');
 if(rail&&previous&&next){
  const mobile=()=>matchMedia('(max-width:749px)').matches;
  const update=()=>{
   const horizontal=mobile();
   const position=horizontal?rail.scrollLeft:rail.scrollTop;
   const visible=horizontal?rail.clientWidth:rail.clientHeight;
   const extent=horizontal?rail.scrollWidth:rail.scrollHeight;
   previous.hidden=horizontal||position<=3;
   next.hidden=horizontal||extent-visible-position<=3;
  };
  for(const [arrow,direction] of [[previous,-1],[next,1]]){
   arrow.addEventListener('click',()=>{
    rail.scrollBy({top:direction*180,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
   });
  }
  rail.addEventListener('scroll',update,{passive:true});
  window.addEventListener('resize',update,{passive:true});
  if('ResizeObserver'in window)new ResizeObserver(update).observe(rail);
  requestAnimationFrame(update);
 }
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
else boot();
})();